import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const AlertContainer = styled.section`
  display: flex;
  align-items: flex-start;
  width: 100%;
  border-radius: 8px;
  text-align: left;
  font-weight: bold;
  
  &:last-of-type{
      margin: 0 0 32px 0 !important;
  }

  .icon-container {
    margin: 0 16px 0 24px;
  }

  &.error {
    margin-bottom: 16px;
    background-color: ${(props) => props.theme.error10};
    border: solid 1px ${(props) => props.theme.borderWhite};
  }

  &.warning {
    margin-bottom: 16px;
    background-color: ${(props) => props.theme.warning};
    border: solid 1px ${(props) => props.theme.borderWhite};
  }

  &.info {
    margin-bottom: 16px;
    background-color: ${(props) => props.theme.info};
    border: solid 1px ${(props) => props.theme.borderWhite};
  }

  &.success {
    margin-bottom: 16px;
    background-color: ${(props) => props.theme.success10};
    border: solid 1px ${(props) => props.theme.borderWhite};
  }

  h3 {
    font-size: ${theme.font.size16};
    font-weight: bold;
    margin: 0;
    color: ${(props) => props.theme.black};
  }

  span {
    font-weight: normal;
    font-size: ${theme.font.size16};
    color: ${(props) => props.theme.grey};
  }

  & .text-container {
    display: flex;
    flex-direction: column;
    padding: 22px 24px 16px 0;
    line-height: 20px;
    gap: 16px;

    a {
      color: ${(props) => props.theme.grey};
    }
  }
`;

export const AlignMessage = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  min-height: 64px;
`;

export const AlignIcon = styled.div`
padding: 16px 0 0 0;
`;
